import React from 'react';
import { Mail, Phone } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';

interface ContactInfo {
  name: string;
  email: string;
  phone: string;
  role: 'Wholesale AE' | 'Correspondent AE' | 'Account Executive';
  company: string;
}

interface ContactCardProps {
  contact: ContactInfo;
  children: React.ReactNode;
  /** Extra class for the portaled content (e.g. the v2 theme scope class). */
  contentClassName?: string;
}

export const ContactCard: React.FC<ContactCardProps> = ({ contact, children, contentClassName = '' }) => {

  return (
    <Popover>
      <PopoverTrigger asChild>
        {children}
      </PopoverTrigger>
      <PopoverContent align="start" className={`w-72 p-0 ${contentClassName}`.trim()}>
        <div className="p-4">
          {/* Header */}
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center text-primary text-lg font-semibold">
              {contact.name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2)}
            </div>
            <div>
              <div className="font-semibold text-foreground">{contact.name}</div>
              <div className="text-sm text-muted-foreground">{contact.role}</div>
            </div>
          </div>

          {/* Contact Details */}
          <div className="space-y-2">
            <div className="flex items-center gap-2 text-sm">
              <Mail className="h-4 w-4 text-muted-foreground" />
              <span className="text-foreground">{contact.email}</span>
            </div>
            <div className="flex items-center gap-2 text-sm">
              <Phone className="h-4 w-4 text-muted-foreground" />
              <span className="text-foreground">{contact.phone}</span>
            </div>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
};
